'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'signal-stream-slash';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'e250';
var svgPathData = 'M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM576 256c0-70.7-25.5-135.5-67.8-185.6c-5.7-6.8-15.8-7.6-22.5-1.9s-7.6 15.8-1.9 22.5C521.4 135.6 544 193.1 544 256c0 29.5-5 57.8-14.1 84.1L556.3 361C569 328.5 576 293 576 256zm-96 0c0-46.4-16.5-89-43.9-122.2c-5.6-6.8-15.7-7.8-22.5-2.1s-7.8 15.7-2.1 22.5C434.3 181.9 448 217.3 448 256c0 6.3-.4 12.5-1.1 18.7l28.6 22.6c2.9-13.3 4.4-27.1 4.4-41.3zM139.9 195.3l-26-20.5C102.4 199.5 96 227 96 256c0 46.4 16.5 89 43.9 122.2c5.6 6.8 15.7 7.8 22.5 2.1s7.8-15.7 2.1-22.5C141.7 330.1 128 294.7 128 256c0-21.5 4.2-42 11.9-60.7zm-77.2-61L37.2 114.3C13.5 156.1 0 204.5 0 256c0 70.7 25.5 135.5 67.8 185.6c5.7 6.8 15.8 7.6 22.5 1.9s7.6-15.8 1.9-22.5C54.6 376.4 32 318.9 32 256c0-44 11.1-85.4 30.7-121.6z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSignalStreamSlash = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;